import gettext from '@sdk/lang/gettext';
import TextInputBase from '@sdk/components/forms/TextInputBase';
import { FormLabel } from '@sdk/components/ui/modalForm/modalForm.styles';
import { useFormContext } from 'react-hook-form';

import TaskIcon from '@web/assets/svg/Icons/32/task-gray.svg';

export const TitleField = () => {
  const {
    register,
    formState: { errors },
  } = useFormContext();

  return (
    <>
      <FormLabel htmlFor="task-template-title-field">
        {gettext('title')} <TaskIcon aria-hidden={true} />
      </FormLabel>
      <TextInputBase
        {...register('title', { required: true })}
        maxLength={256}
        id="task-template-title-field"
        placeholder={gettext('Add a title')}
        invalid={Boolean(errors.title)}
      />
    </>
  );
};
